import { useEffect, useState } from "react";
import "./App.css";
import MainLayoutSubmitter from "./Layout/MainLayoutSubmitter";
import MainRoutesSubmitter from "./Routes/MainRoutesSubmitter/MainRoutesSubmitter";
import LogInServices from "./Services/Account/LogInServices";
import { useCookies } from "react-cookie";
import loadConfig from "./Services/Api/ApiServices";
import { GetJsonData } from "./Redux/Reducers/Shared/FetchDataJson";
import { useDispatch, useSelector } from "react-redux";
import { decryptToken } from "./Services/Encryption/EncryptionToken";
import { useParams } from "react-router-dom";
import { GetApplicationInformation } from "./Redux/Reducers/Shared/ApplicationInformation";
import { SetDataUser } from "./Redux/Reducers/Shared/UserInfo";
import { SetLogin } from "./Redux/Reducers/Shared/Login";
import './Assets/SharedStyle/style.css';
import { GetActiveRound } from "./Redux/Reducers/Shared/Round";
import LogInManagerServices from "./Services/Account/LogInManagerServices";
import { GetRoleByUserGuid } from "./Redux/Reducers/Shared/RoleByUser";
import MainLayoutManager from "./Layout/MainLayoutManager";
import MainRoutsManager from "./Routes/MainRoutesManager/MainRoutesManager";
import LoaderAHSF from "./Components/LoaderAHSF";

function App() {
    const renderData=useSelector((state)=>state.ApplicationInformationReducers.ChangeApplicationStatus)
  
  const loginState = useSelector((state) => state.Login.Login);

  const isAnyLoading = useSelector(state => state.globalLoading.pendingRequests > 0);

  const dispatch = useDispatch();
  const [loginStatus, setLoginStatus] = useState();

  const [cookies, setCookie] = useCookies([]);
  const AppGuid = useParams();

  const state = useSelector((state) => {
    return {
      FetchDataJson: state.FetchDataJson,
    };
  });

  useEffect(() => {
    dispatch(GetActiveRound());
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("ApplicationInformationId") ||
      decryptToken(AppGuid.AppGuid)
    ) {
      //to get application info by id
      dispatch(
        GetApplicationInformation({
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            decryptToken(AppGuid.AppGuid),
        })
      );
    }
  }, [
    localStorage.getItem("ApplicationInformationId"),
    decryptToken(AppGuid.AppGuid),
    renderData
  ]);

  useEffect(() => {
    dispatch(GetJsonData());
  }, []);

  const logIn = async () => {
    console.log("malekjjjjjjjjjj");

    let userInfo = await LogInServices();
    console.log(userInfo, "malekjjjjjjjjjj");

    dispatch(SetDataUser(userInfo));
    dispatch(SetLogin(userInfo.login));
    setLoginStatus(userInfo.login);

    console.log(userInfo, "userInfo");
  };

  // useEffect(() => {
  //   if (!cookies.loginTokenSSO) {
  //     logIn();
  //     // setLoginStatus("sso");
  //   }
  // }, []);
console.log(loginState,"dddddddddfefeffeee");

  const getJson = async () => {
    var json = await loadConfig();
    if (Object.keys(json).length > 1) {
      // setJsonLoding(true);
    }
  };
  useEffect(() => {
    getJson();
  }, []);
  let a=""
  const logInManager = async () => {
    let userInfo = await LogInManagerServices();
    console.log(userInfo,"ssssdddddddddddddsdwd");
    
    dispatch(GetRoleByUserGuid(userInfo.userToken.userGuid));
    dispatch(SetDataUser(userInfo));
    dispatch(SetLogin(userInfo.login));
    setLoginStatus(userInfo.login);
    //console.log(userInfo, "userInfo");
  };


  const loginFrom = async () => {
    // if (window.location.pathname == "/grants/manager/") {
    //[,]
    //if login from manager
    if (window.location.href.includes("manager")) {
      logInManager();
      setLoginStatus("manager");
    } else {
      //[,]
      //if login from sso
      if (!cookies.loginTokenSSO) {
        logIn();
        setLoginStatus("sso");
      }
    }
  };

useEffect(()=>{
  loginFrom();
},[a])


console.log(state.FetchDataJson,"dsssssssefef");


  return (
    <div className="App">
      {
        state.FetchDataJson?.JsonData ? <>
          {
            loginState == "sso" ? <>
              <MainLayoutSubmitter>
                <MainRoutesSubmitter />
              </MainLayoutSubmitter>

            </> : <></>
          }
          {
            loginState == "manager" ? <>

              <MainLayoutManager>
                <MainRoutsManager   />
              </MainLayoutManager>
            </> : <></>
          }
        </> : <></>
      }
      <LoaderAHSF show={isAnyLoading}/>
    </div>
  );
}

export default App;
